<app-reporting-mode-indicator
  [isReportingActive]="isReportingModeActive"
></app-reporting-mode-indicator>

<div class="position-absolute bottom-7 start-20">
  <app-scale-control></app-scale-control>
</div>

<app-datasource-dropdown />

<div
  class="position-absolute bottom-7 end-5 z-3 shadow-sm rounded-2 bg-dark cursor-pointer border border-darkgray d-flex gap-2 align-items-center text-deactivated"
>
  <div class="d-flex">
    <div
      class="d-flex flex-column justify-content-center p-2 text-deactivated"
      placement="top"
      ngbTooltip="Show history mode"
      tooltipClass="custom-tooltip"
      [openDelay]="1000"
      data-cy="history-mode-btn"
    >
      <span
        class="rb-ic rb-ic-history fs-2xl ho-layer-text"
        (click)="toggleHistory()"
        [class.sel-menu-item]="isHistoryVisible"
      ></span>
    </div>
  </div>
</div>
<app-map-navigation>
  <span class="border-bottom border-darkgray"></span>

  <span
    class="rb-ic rb-ic-alert-info fs-2xl hover-effect p-2"
    [class.sel-menu-item]="isLegendVisible"
    (click)="toggleLegend()"
    placement="start"
    ngbTooltip="Show legend"
    tooltipClass="custom-tooltip"
    [openDelay]="1000"
  >
  </span>

  @if (!appState.isHistoryEnabled()) {
    <span class="border-bottom border-darkgray"></span>
    <span
      class="rb-ic rb-ic-alert-warning fs-2xl hover-effect p-2"
      [class.sel-menu-item]="isReportingModeActive"
      [class.rounded-bottom-2]="isReportingModeActive"
      [style.color]="isReportingModeActive ? '#ff6600' : ''"
      (click)="toggleReportingMode()"
      placement="start"
      ngbTooltip="Reporting mode"
      tooltipClass="custom-tooltip"
      [openDelay]="1000"
      data-cy="reporting-mode-btn"
    >
    </span>
  }
</app-map-navigation>

@if (isLegendVisible) {
  <app-customer-legend></app-customer-legend>
}

<app-customer-data-layer-config></app-customer-data-layer-config>

<app-rollouts-map-tile-segment-details></app-rollouts-map-tile-segment-details>

<app-rollouts-map-tile-matched-signs-details
  data-cy="matched-signs-details"
></app-rollouts-map-tile-matched-signs-details>

@if (isReportingModeActive) {
  <app-customer-map-report-dialog data-cy="map-report-dialog"></app-customer-map-report-dialog>
}

<app-rollout-date></app-rollout-date>

@if (isHistoryVisible) {
  <app-customer-history-control
    (historyClosed)="handleHistoryClosed()"
  ></app-customer-history-control>
}
